import momentDate from 'utils/momentDate';
import { getThumbUrlFromItem } from 'utils/deepProps';
import tulkojumi from 'utils/tulkojumi';

const transformData = (data, lang) => {
  const { id, teksti } = data;

  const banner = data.banner && {
    image: data.banner.src,
  };

  const primaryCards = {
    title: teksti.find(str => str._id === id).text,
    items: (data.page || []).map(item => {

      let acf = {}
      if(item.acf){
        acf = JSON.parse(item.acf);
      }
      return (item && item.acf) ? {
        title: item.title,
        description: acf.apraksts,
        thumbnail: getThumbUrlFromItem(item),
        location: item.path,
        rewrite_url: item.rewrite_url,
        rewrite_source: item.rewrite_source,
        rewrite_target: item.rewrite_target,
      }: null;

    }),
  };

  const noderigi_icons = [
    'document',
    'sort-alpha',
    'contacts',
  ];
  const noderigi_accents = [
    'primary',
    'default',
    'secondary',
  ];

  const noderigi = {
    title: teksti.find(str => str._id === 'noderigi').text,
    items: (data.noderigi || []).map((item, i) => ({
      title: item.nosaukums,
      icon: noderigi_icons[i],
      accent: noderigi_accents[i],
      location: item.post && item.post.path,
      rewrite_url: item.post && item.post.rewrite_url,
      rewrite_source: item.post && item.post.rewrite_source,
      rewrite_target: item.post && item.post.rewrite_target,
    })),
  };

  const jaunumi = {
    title: teksti.find(str => str._id === 'jaunumi').text,
    items: (data.jaunumi || []).posts.map(item => {
      return {
        title: item.title,
        date: momentDate(item.date_created, lang),
        location: item.path,
      };
    }),
    more: {
      label: tulkojumi(teksti, 'skatit_vairak_jaunumus'),
      location: data.jaunumiLapa &&
        data.jaunumiLapa.length > 0 &&
        data.jaunumiLapa[0].path,
    },
  };

  const composedData = {
    banner,
    sections: {
      [id]: primaryCards,
      noderigi,
      jaunumi,
    },
  };

  return composedData;
};

export default transformData;



// WEBPACK FOOTER //
// ./src/pages/Kategorija/transformData.js